// src/components/ReceiptModal.jsx
import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./ReceiptModal.css"; // Agar custom styling alag rakhni ho
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
// import ShowImagePath from "../../Others/ImportantFunction";
// import { useAuth } from "../../../Store/AuthContext";

export default function ReceiptModal({ show, onClose, transaction }) {
  const receiptRef = useRef(null);
  //   const { webSetting } = useAuth();
  const [loading, setLoading] = useState(false);
  if (!show) return null;

  const handleDownloadPDF = async () => {
    try {
      setLoading(true); // 👈 loader start
      const element = receiptRef.current;

      const canvas = await html2canvas(element, {
        scale: 2,
        ignoreElements: (el) => el.classList.contains("exclude-pdf"),
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`Receipt_${transaction.transactionId}.pdf`);
       NotifyMessageNoReload("Download Successfully !", "success");
    } catch (error) {
      console.error("PDF Download Error:", error);
    } finally {
      setLoading(false); // 👈 loader stop
    }
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <div className="receipt-overlay">
      <div className="receipt-modal" ref={receiptRef}>
        {/* Header */}
        <div className="receipt-header">
          <h4>PAYMENT RECEIPT</h4>
          <p>Official Transaction Confirmation</p>
          {/* <div className="sitelogo">
            <img
              src={webSetting.footer_logo && ImageShowimage}
              alt=""
              title=""
              className="moudleLogo"
            />
          </div> */}
          {/* <div className="transactionbox">
            <div className="receipt-row">
              <span>Receipt No.</span>
              <span>{transaction.receipt_no}</span>
            </div>
            <div className="receipt-row">
              <span>Transaction Date</span>
              <span>{transaction.payment_date}</span>
            </div>
          </div> */}
        </div>

        {/* Body */}
        <div className="receipt-body">
          <div className="transactionbox">
            <div className="receipt-row">
              <span className="receptFirst">Receipt No.</span>
              <span className="receptSecond">{transaction.receipt_id}</span>
            </div>
            <div className="receipt-row">
              <span className="receptFirst">Transaction Date</span>
              <span className="receptSecond"> {transaction.payment_date}</span>
            </div>
          </div>
          <div className="receiptdivider mt-4">
            <span className="divider-text">Transaction Details</span>
          </div>

          <div className="receipt-amount">
            <span
              className={
                transaction.credit_debit_type === "1"
                  ? "text-success transAmount"
                  : "text-danger transAmount"
              }
            >
              {transaction.credit_debit_type === "1"
                ? `₹${transaction.amount}`
                : `₹${transaction.amount}`}
            </span>

            <span
              className={`payment_status badge ${
                transaction.credit_debit_type === "1" ? "bg-info" : "bg-danger"
              }`}
            >
              {transaction.credit_debit_type === "1" ? "Credit" : "Debit"}
            </span>
          </div>

          <div className="receipt-row">
            <span className="receptFirst">Transaction ID</span>
            <span className="receptSecond">{transaction.transactionId}</span>
          </div>
          <div className="receipt-row">
            <span className="receptFirst">Reference No.</span>
            <span className="receptSecond">{transaction.referenceNo}</span>
          </div>
          {transaction.lead_id && (
            <div className="receipt-row">
              <span className="receptFirst">Lead ID</span>
              <span className="receptSecond">{transaction.lead_id}</span>
            </div>
          )}

          {/* <div className="receipt-row">
            <span className="receptFirst">Previous Balance</span>
            <span className="receptSecond">
              ₹{transaction.previous_balance}
            </span>
          </div> */}
          <div className="receipt-row">
            <span className="receptFirst">Transaction Amount</span>
            {/* <span className="text-success receptSecond">
              +₹{transaction.amount}
            </span> */}
            <span
              className={
                transaction.credit_debit_type === "1"
                  ? "text-success receptSecond"
                  : "text-danger receptSecond"
              }
            >
              {transaction.credit_debit_type === "1"
                ? `₹${transaction.amount}`
                : `₹${transaction.amount}`}
            </span>
          </div>

          <div className="receipt-row">
            <span className="receptFirst">Payment Staus</span>
            {/* <span
              className={`badge ${
                transaction.credit_debit_type === "1" ? "bg-info" : "bg-danger"
              }`}
            >
              {transaction.credit_debit_type === "1" ? "Credit" : "Debit"}
            </span> */}
            <span
              className={` badge ${
                transaction.payment_status === "1" ? "bg-success" : "bg-danger"
              }`}
            >
              {transaction.payment_status === "1" ? "Complete" : "Falid"}
            </span>
          </div>

          <div className="receiptdivider my-4">
            <span className="divider-text">User Information</span>
          </div>

          <div className="receipt-row">
            <span className="receptFirst">Name</span>
            <span className="receptSecond">{transaction.name}</span>
          </div>
          <div className="receipt-row">
            <span className="receptFirst">Mobile Number</span>
            <span className="receptSecond">{transaction.phone}</span>
          </div>
          <div className="receipt-row">
            <span className="receptFirst">Email</span>
            <span className="receptSecond">{transaction.email}</span>
          </div>

          <div className="receipt-secured">
            <span>🔒 Secured Transaction</span>
            <span>✔ Verified Payment</span>
          </div>
        </div>

        {/* Footer */}
        <div className="receipt-footer">
          <p className="mb-1">Thank you for choosing YourDoorstep</p>
          <span>
            This is a computer generated receipt. No signature required.
            <br />
            For any queries, contact <b>support@yourdoorstep.co</b> or call{" "}
            <b>+91 9540005064</b>
          </span>
        </div>

        {/* Actions */}
        <div className="receipt-actions exclude-pdf">
          <button
            onClick={onClose}
            className="theme-btn btn-style-three submitbtn"
            disabled={loading}
          >
            Close
          </button>
          <button
            onClick={handleDownloadPDF}
            className="btn-download"
            disabled={loading}
          >
            {loading ? "Downloading..." : "Download"}
          </button>
        </div>
      </div>
    </div>
  );
}
